import { formatCurrency, formatTime } from '../../../utils/datetime';

const DayCloseSummary = ({ appointments, currency }) => {
  const confirmed = appointments.filter((a) => a.status === 'confirmed').length;
  const arrived = appointments.filter((a) => a.status === 'arrived').length;
  const completed = appointments.filter((a) => a.status === 'completed');
  const cancelled = appointments.filter((a) => a.status === 'cancelled').length;
  const noShow = appointments.filter((a) => a.status === 'no_show').length;
  const revenue = completed.reduce(
    (sum, appt) => sum + (Number(appt.price) || Number(appt.service?.price) || 0),
    0
  );
  const openFloor = confirmed + arrived;

  return (
    <div className="space-y-6">
      <div>
        <h2 className="font-display text-2xl font-light text-ink-900">Day close</h2>
        <p className="mt-1 text-sm text-ink-700/80">
          Snapshot of today before you shut the till. Settle any open visits first.
        </p>
      </div>

      {openFloor > 0 && (
        <div className="border border-saffron-500/40 bg-saffron-500/10 px-4 py-3 text-sm text-ink-900">
          {openFloor} visit{openFloor === 1 ? '' : 's'} still open (confirmed or on the floor).
        </div>
      )}

      <div className="grid grid-cols-2 gap-3 lg:grid-cols-4">
        {[
          { label: 'Booked', value: appointments.length },
          { label: 'Completed', value: completed.length },
          { label: 'Cancelled', value: cancelled },
          { label: 'No shows', value: noShow },
        ].map((item) => (
          <div key={item.label} className="bg-sand-50 px-4 py-4 ring-1 ring-ink-900/10">
            <p className="text-[11px] font-semibold uppercase tracking-[0.14em] text-ink-600/60">
              {item.label}
            </p>
            <p className="mt-2 font-display text-3xl font-light tabular-nums text-ink-900">
              {item.value}
            </p>
          </div>
        ))}
      </div>

      <div className="bg-sand-50 p-5 ring-1 ring-ink-900/10 sm:p-6">
        <p className="text-xs font-semibold uppercase tracking-[0.14em] text-ink-600/60">
          Revenue closed
        </p>
        <p className="mt-2 font-display text-4xl font-light text-ink-900">
          {formatCurrency(revenue, currency)}
        </p>
      </div>

      {completed.length > 0 && (
        <div className="bg-sand-50 ring-1 ring-ink-900/10">
          <p className="border-b border-ink-900/10 px-5 py-3 text-xs font-semibold uppercase tracking-[0.14em] text-ink-600/60">
            Closed visits
          </p>
          <ul className="divide-y divide-ink-900/10">
            {completed.map((appt) => (
              <li key={appt.id} className="flex items-center justify-between gap-4 px-5 py-3 text-sm">
                <span className="min-w-0 truncate text-ink-900">
                  <span className="tabular-nums text-ink-600/70">{formatTime(appt.startAt)}</span>
                  {' · '}
                  {appt.client?.name || 'Client'}
                </span>
                <span className="flex-none font-medium text-ink-900">
                  {formatCurrency(appt.price || appt.service?.price || 0, appt.currency || currency)}
                </span>
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};

export default DayCloseSummary;
